import { AbstractProductDataCommand } from "./abstractProductDataCommand";

export class AssortmentCommand extends AbstractProductDataCommand {
  isRoot?: boolean;
  productLevel?: number;
  productFamilyLevel?: number;
}